module.exports = __webpack_public_path__ + "static/img/24.6d3ba2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/24.png
// module id = 6Evt
// module chunks = 0